/*
 * @Author: 陈乾
 * @Date: 2021-10-25 10:59:32
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 15:01:11
 * @Description: file content
 * @FilePath: /Cheers 上线速览/src/api/base.js
 */
import { get, post } from '@/utils/request'
import qs from 'qs'

export default {
  // 企业微信流程示例保留
  getUserInfo(code) {
    return get('xxxxxxx', { code })
  },
  // 账号密码登录
  login(payload) {
    // 使用表单提交，满足后端可能的表单请求要求
    const body = qs.stringify(payload)
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        // 补充后端白名单中允许的自定义头，提升通过率
        'Accept-Language': typeof navigator !== 'undefined' && navigator.language ? navigator.language : 'zh-CN',
        platform: 'h5'
      }
    }
    // 某些后端会在首次请求返回 403 并下发 Set-Cookie 用于会话初始化
    // 此时第二次请求会携带 Cookie 并通过校验，这里做一次自动重试
    return post('login', body, config).catch(err => {
      if (err && err.response && err.response.status === 403) {
        return post('login', body, config)
      }
      throw err
    })
  },
  // 注销登录
  logout() {
    const config = {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept-Language': typeof navigator !== 'undefined' && navigator.language ? navigator.language : 'zh-CN',
        platform: 'h5'
      }
    }
    // 大多数后端使用 POST /logout 使服务端会话失效
    return post('logout', null, config).catch(err => {
      if (err && err.response && err.response.status === 403) {
        return post('logout', null, config)
      }
      throw err
    })
  },
  // 企业微信授权入口（需在企业微信环境打开）
  wechatAuth(params = {}) {
    return get('wechat-auth', params)
  },
  // 企业微信授权回调（后端根据 code 交换用户信息）
  wechatCallback(params = {}) {
    return get('wechat-callback', params)
  },
  // 门店仪表盘数据
  storeDashboard() {
    return get('storeDashboard')
  }
}
